import {
  LayoutDashboard, PieChart, Globe, Building2, Vault, Moon, Wallet as WalletIcon,
  Globe2, Gem, DollarSign, Bitcoin, Sprout, BellRing, LineChart, Activity, CandlestickChart,
  Landmark, Compass, Receipt, ListChecks, HandCoins, Coins, ShieldCheck, BookOpen, Gavel, SearchCheck, Trophy, Sparkles,
} from "lucide-react";

// Sidebar sections. Items with `children` render as an expandable group.
export const navSections = (t) => [
  {
    label: "Overview",
    items: [
      { to: "/", label: t("nav_dashboard"), icon: LayoutDashboard, testid: "top-nav-dashboard-link", end: true },
      { to: "/live", label: t("nav_live"), icon: Activity, testid: "top-nav-live-link", pro: true },
      { to: "/insights", label: t("nav_insights"), icon: LineChart, testid: "top-nav-insights-link", pro: true },
      { to: "/invest", label: t("nav_invest"), icon: PieChart, testid: "top-nav-invest-link" },
      { to: "/orders", label: t("nav_orders"), icon: ListChecks, testid: "top-nav-orders-link", pro: true },
    ],
  },
  {
    label: "Markets",
    items: [
      {
        label: t("nav_g_stocks"), icon: CandlestickChart, testid: "top-nav-stocks-group", children: [
          { to: "/trade-global", label: "US Stocks", icon: Globe, testid: "top-nav-trade-global-link" },
          { to: "/trade-eu", label: t("nav_eu"), icon: Landmark, testid: "top-nav-trade-eu-link" },
          { to: "/trade-asia", label: t("nav_asia"), icon: Globe2, testid: "top-nav-trade-asia-link" },
          { to: "/trade-gcc", label: "GCC Stocks", icon: Building2, testid: "top-nav-trade-gcc-link" },
          { to: "/trade-world", label: t("nav_world"), icon: Compass, testid: "top-nav-world-link" },
        ],
      },
      {
        label: t("nav_g_markets"), icon: Gem, testid: "top-nav-markets-group", children: [
          { to: "/trade-commodities", label: t("nav_commodities"), icon: Gem, testid: "top-nav-commodities-link" },
          { to: "/trade-forex", label: t("nav_forex"), icon: DollarSign, testid: "top-nav-forex-link" },
          { to: "/trade-crypto", label: t("nav_crypto"), icon: Bitcoin, testid: "top-nav-crypto-link" },
        ],
      },
      {
        label: t("nav_g_islamic"), icon: Moon, testid: "top-nav-islamic-group", children: [
          { to: "/halal", label: t("nav_halal"), icon: Moon, testid: "top-nav-halal-link" },
          { to: "/shariah-watch", label: "Shariah Watch", icon: ShieldCheck, testid: "top-nav-shariah-watch-link" },
          { to: "/shariah-board", label: "Shariah Board", icon: Gavel, testid: "top-nav-shariah-board-link" },
          { to: "/top-halal-stocks", label: "Halal Screener", icon: SearchCheck, testid: "top-nav-halal-screener-link" },
          { to: "/halal-leaderboards", label: "Rankings", icon: Trophy, testid: "top-nav-leaderboards-link" },
          { to: "/chart-lens", label: "Chart Lens", icon: Sparkles, testid: "top-nav-chart-lens-link" },
          { to: "/murabaha", label: t("nav_murabaha"), icon: Sprout, testid: "top-nav-murabaha-link" },
          { to: "/zakat", label: t("nav_zakat"), icon: HandCoins, testid: "top-nav-zakat-link" },
        ],
      },
    ],
  },
  {
    label: "Money",
    items: [
      {
        label: t("nav_g_money"), icon: WalletIcon, testid: "top-nav-money-group", children: [
          { to: "/wallet", label: t("nav_wallet"), icon: WalletIcon, testid: "top-nav-wallet-link" },
          { to: "/save", label: t("nav_save"), icon: Vault, testid: "top-nav-save-link" },
          { to: "/dividends", label: t("nav_dividends"), icon: Coins, testid: "top-nav-dividends-link" },
          { to: "/alerts", label: t("nav_alerts"), icon: BellRing, testid: "top-nav-alerts-link", pro: true },
          { to: "/fees", label: "Fees", icon: Receipt, testid: "top-nav-fees-link" },
          { to: "/learn", label: "Learn", icon: BookOpen, testid: "top-nav-learn-link" },
        ],
      },
    ],
  },
];

export const allNavItems = (t) => navSections(t).flatMap((s) => s.items);

/** Simple mode hides the technical screens. Pro mode (a switch in Profile) brings them back.
 *  Nothing is removed — every route still works if you know the URL. */
export const visibleSections = (t, pro) => {
  if (pro) return navSections(t);
  const keep = (item) => !item.pro;
  return navSections(t)
    .map((section) => ({
      ...section,
      items: section.items.filter(keep).map((item) => (
        item.children ? { ...item, children: item.children.filter(keep) } : item
      )).filter((item) => !item.children || item.children.length),
    }))
    .filter((section) => section.items.length);
};

export const itemClass = (active) =>
  `w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition-colors active:scale-[0.98] ${
    active
      ? "bg-card text-foreground font-semibold shadow-premium"
      : "text-muted-foreground hover:text-foreground hover:bg-card/60 font-medium"
  }`;
